import { render } from "./HomeCTA.vue?vue&type=template&id=dd3600a8&scoped=true&ts=true"
import script from "./HomeCTA.vue?vue&type=script&lang=ts"
export * from "./HomeCTA.vue?vue&type=script&lang=ts"

import "./HomeCTA.vue?vue&type=style&index=0&id=dd3600a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd3600a8"]])

export default __exports__